import React, { useState, useEffect } from "react";
import { isPlatform } from "@ionic/react";
import * as Constants from "../../../../utils/constants";
import './Splash.scss';

const SplashHOC: React.FC<any> = React.memo(({ WrappedComponent }) => {
  const [splash, showSplash] = useState(true);
  useEffect(() => {
    if (isPlatform("capacitor")) {
      const timer = setTimeout(() => {
        showSplash(false);
      }, Constants.splashShowDuration);
      return () => clearTimeout(timer);
    } else {
      showSplash(false);
    }
  }, []);

  return splash ? (
    <div>
      <div className="splash_screen">
        <img src= {Constants.splashImage} alt=""/>
      </div>
    </div>
  ) : WrappedComponent
});

export default React.memo(SplashHOC);
